<template>
  <div class="plhksq-exam">
    <Header title="缓考" type="0" route="/homeIndex"></Header>
    <div class="plhksq-search">
      <i class="search-icon"></i>
      <input type="text" placeholder="搜索课程(名称或课号)" v-model="value" />
    </div>
    <div class="search-info">
      <div class="sem-drop">
        <div @click="showPop('学年学期', 'xnxq')">
          <p>{{ xnxq.mc }}</p>
          <i></i>
        </div>
        <div @click="showPop('活动名称', 'hdmc')">
          <p>{{ hdmc.mc }}</p>
          <i></i>
        </div>
      </div>
    </div>
    <NOdata v-if="this.list.length == 0" title="暂无缓考数据~"></NOdata>
    <div v-else>
      <van-checkbox-group v-model="checkedArr" @change="change">
        <van-row
          gutter="20"
          class="grey-contain"
          v-for="(item, index) in list"
          :key="index"
          @click="goApply(item)"
        >
          <van-col span="3">
            <van-checkbox
              shape="square"
              :name="index"
              checked-color="#7469F8"
              @click.stop.native="() => {}"
            ></van-checkbox>
          </van-col>
          <van-col span="21">
            <p class="contain-txt">{{ item.courseName }}</p>
            <p class="contain-txt1">学时：{{ item.period }}</p>
            <p class="contain-txt1">学分：{{ item.credit }}</p>
          </van-col>
        </van-row>
      </van-checkbox-group>
    </div>
    <div class="plhksq-btn">
      <button v-if="multiple" @click="multipleGo">批量申请</button>
      <button @click="goMyapply()">我的缓考申请</button>
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.label"
        show-toolbar
        :columns="valueList.item"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.value);
          }
        "
      />
    </van-popup>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
import tApi from "@/utils/teacher";

export default {
  data() {
    return {
      value: "",
      xnxq: {},
      hdmc: {},
      list: "",
      checkedArr: [],
      multiple: false,
      show: false,
      columns: {
        jxzcXq: [],
        jc: []
      },
      valueList: {
        label: "",
        value: "",
        item: []
      },
      zdxzms: ""
    };
  },
  created() {
    this.getXnxq();
  },
  methods: {
    goMyapply() {
      this.$router.push({
        path: "/plhksq/myApply"
      });
    },
    multipleGo() {
      if (
        this.zdxzms !== "" &&
        Number(this.zdxzms) < this.checkedArr.length
      ) {
        this.$toast.fail("批量申请最多一次申请" + this.zdxzms + "门");
        return;
      }
      let paramslist = [];
      this.checkedArr.forEach(index => {
        let item = this.list[index];
        paramslist.push(item);
      });

      this.$router.push({
        path: "/plhksq/apply",
        query: {
          data: JSON.stringify(paramslist)
        }
      });
    },
    goApply(item) {
      this.$router.push({
        path: "/plhksq/apply",
        query: {
          data: JSON.stringify([item])
        }
      });
    },
    change(arr) {
      if (arr.length > 1) {
        this.multiple = true;
      } else {
        this.multiple = false;
      }
    },
    async getXnxq() {
      const res = await Api.getSemesterList();
      this.columns.xnxq = [
        {
          values: res.data.map((item, index) => {
            if (index == 0) {
              this.xnxq = {
                mc: item.semesterName,
                dm: item.semesterId
              };
            }
            return {
              text: item.semesterName,
              value: item.semesterId
            };
          })
        }
      ];
      this.getHdmc();
    },
    async getHdmc() {
      const res = await Api.getActivityName({
        semester: this.xnxq.dm
      });
      this.columns.hdmc = [
        {
          values: res.data.map((item, index) => {
            if (index == 0) {
              this.hdmc = {
                mc: item.ACTIVITYNAME,
                dm: item.CJ0701ID
              };
            }
            return {
              text: item.ACTIVITYNAME,
              value: item.CJ0701ID
            };
          })
        }
      ];
      this.getList();
    },
    async getList() {
      const res = await Api.getSlowExamination({
        semester: this.xnxq.dm,
        courseName: this.value,
        cj0701id: this.hdmc.dm
      });
      if (res.code == "1") {
        this.list = res.data.datalist;
        this.zdxzms = res.data.zdxzms;
      }
    },
    // 弹出选择器
    showPop(label, value) {
      this.show = true;
      this.valueList.label = label;
      this.valueList.value = value;
      this.valueList.item = this.columns[value];
    },
    onConfirm(value, index, value1) {
      this.show = false;
      this[value1].mc = value[0].text;
      this[value1].dm = value[0].value;
      this.getList();
    }
  }
};
</script>

<style lang="less" scoped>
.plhksq-exam .grey-contain .contain-txt {
  line-height: 22px;
}
.plhksq-exam .grey-contain .contain-txt1 {
  line-height: 17px;
}
.plhksq-search {
  background-color: @attendance-background-color-6;
  border-radius: 3px;
  margin: 20px 20px 0;
  padding: 11px 12px;
  display: flex;
}
.search-icon {
  background: url(../../../../../static/img/search.png) no-repeat center;
  width: 20px;
  height: 20px;
  background-size: 100%;
}
.plhksq-search input {
  background-color: @attendance-background-color-6;
  padding-left: 11px;
  flex: 1;
  color: @attendance-color-2;
}
.search-info {
  display: flex;
  justify-content: center;
  border-bottom: 1px solid @attendance-border-color-6;
  padding: 20px 0 7px;
}
.search-info input {
  width: 40%;
  text-align: center;
  padding: 10px 0;
}
.plhksq-btn {
  position: fixed;
  padding: 20px;
  width: 100%;
  text-align: center;
  display: flex;
  bottom: 0;
  background-color: @attendance-color-3;
  box-sizing: border-box;
}
.plhksq-btn button {
  flex: 1;
  background-color: @attendance-background-color-1;
  color: @attendance-color-3;
  padding: 11px 0;
  border-radius: 3px;
}
.plhksq-btn button + button {
  margin-left: 10px;
  background-color: @attendance-background-color-7;
  color: @attendance-background-color-1;
}
.grey-contain:last-child {
  margin-bottom: 80px;
}
.search-info .sem-drop,
.search-info .sem-drop div {
  display: flex;
  align-items: center;
  color: @attendance-color-2;
  font-size: 14px;
  justify-content: center;
}

.search-info .sem-drop {
  width: 80%;
}
.search-info .sem-drop > div {
  width: 45%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.search-info .van-popup.van-popup--bottom {
  border-radius: 5px 5px 0 0;
} /*box-shadow:0px -2px 2px 0px rgba(223,223,223,0.5);*/
.search-info .sem-drop p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
}
.search-info .sem-drop > div {
  position: relative;
}
.search-info .sem-drop > div i {
  background: url(../../../../../static/img/Triangle.png) no-repeat center;
  width: 10px;
  height: 10px;
  background-size: 10px 8px;
  margin-left: 5px;
}
.search-info
  .van-ellipsis.van-picker-column__item.van-picker-column__item--selected {
  font-weight: 600;
  color: @attendance-color-1;
}
.search-info .van-picker__columns::before {
  width: 150px;
  height: 1px;
  background-color: @attendance-background-color-2;
  content: "";
  position: absolute;
  top: 70px;
  left: 50%;
  transform: translateX(-50%);
}
.search-info .van-picker__columns::after {
  width: 150px;
  height: 1px;
  background-color: @attendance-background-color-2;
  content: "";
  position: absolute;
  bottom: 70px;
  left: 50%;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/plhksq/index.vue